
import "./loader.css";
const ItemLoader = () => {
  return (
    <div className="">
      <div className="small-loader small-loader-center"></div>
    </div>
  );
};

export default ItemLoader;